export default "__VITE_ASSET__CNuMlY6F__"